import * as React from 'react';
import { ConnectedSharedWithMeSpace } from './ConnectedSharedWithMeSpace';
import { SharedWithMeSpaceAngularProps, SharedWithMeSpaceOwnProps } from './SharedWithMeSpace';
import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { ToasterService } from '../../../ts/services/ToasterService';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';

export interface SharedWithMeSpaceProviderProps extends SharedWithMeSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const SharedWithMeSpaceAngularHOC = angularProviderHOC<SharedWithMeSpaceOwnProps, SharedWithMeSpaceAngularProps, SharedWithMeSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    browserTitleService: BrowserTitleService,
    toasterService: ToasterService.instance,
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedSharedWithMeSpace: React.ComponentType<SharedWithMeSpaceOwnProps>
  = SharedWithMeSpaceAngularHOC(ConnectedSharedWithMeSpace);

const SharedWithMeSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sharedWithMe',
  subspaceName: undefined
};

export const SharedWithMeSpaceProvider: React.FunctionComponent<SharedWithMeSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={SharedWithMeSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={false}
        shouldUpdateSort={false}
      ></ConnectedQueryParamUpdateProvider>
      <AngularWrappedSharedWithMeSpace
        angularContext={props.angularContext}
      // TODO Add props that needs to be passed to the space here
      />
    </ConnectedSpaceInfoProvider>
  );
};
